import * as saleReports from './list'

import { SaleReport } from 'app/types/reports/sale'

export const allSaleReports: SaleReport[] = Object.values(saleReports).sort(
    (previous, current) =>
        current.creation_datetime.localeCompare(previous.creation_datetime),
)
